<div class="list-container">
  <dynamic-table [props]="props">
    <table class="table">
      <thead>
        <tr class="table-header">
          <th id="RequestCategory" class="table-header-title">
            {{ "request.RequestCategory" | translate }}
          </th>
          <th id="DictionaryRequestTypeName" class="table-header-title">
            {{ "request.DictionaryRequestTypeName" | translate }}
          </th>
          <th id="CreatedOn" class="table-header-title">
            {{ "request.CreatedOn" | translate }}
          </th>
          <th id="PartnerName" class="table-header-title">
            {{ "request.PartnerName" | translate }}
          </th>
          <th id="UserName" class="table-header-title">
            {{ "request.UserName" | translate }}
          </th>
          <th id="Status" class="table-header-title">
            {{ "request.Status" | translate }}
          </th>
          <th id="StatusHistory" class="table-header-title">
            {{ "request.StatusHistory" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let request of requests">
          <tr class="row-container ccc ccc-table-row ccc-hover" (click)="viewDetails(request.requestId, request.dictionaryCategoryTypeId)" role="button">
            <td HJSuppress id="DictionaryRequestCategoryName" class="blue-text-bold">
              {{ request.dictionaryRequestCategoryName }}
            </td>

            <td HJSuppress id="DictionaryRequestTypeName" class="column-content">
              {{ request.dictionaryRequestTypeName }}
            </td>

            <td HJSuppress id="CreatedOn" class="column-content">
              {{ request.createdOn | localizedDate }}
            </td>

            <td HJSuppress id="PartnerName" class="partner-name column-content">
              {{ request.partnerName  }}
            </td>  
            
            <td HJSuppress id="UserName" class="column-content">
              {{ request.userName | replaceIfNull }}
            </td>
            
            <td class="status-box">
              <div class="status-content">
                <div class="status-dot"
                  [ngClass]="request.dictionaryRequestStatus.code===dictionaryRequestStatus.POSTED ? 'status-posted':
                            request.dictionaryRequestStatus.code===dictionaryRequestStatus.IN_PROGRESS ? 'status-in-progress': 
                            request.dictionaryRequestStatus.code===dictionaryRequestStatus.RESOLVED ? 'status-resolved': 
                            request.dictionaryRequestStatus.code===dictionaryRequestStatus.CLOSED ? 'status-closed': ''">
                </div>
                <div HJSuppress class="status-value">{{ request.dictionaryRequestStatus.value | replaceIfNull }}</div>
              </div>
             
            </td>
          <td class="status-box">
            <div HJSuppress class="status-value">{{"request.statusChange.UpdatedBy" | translate}}: {{request?.statusUpdatedByUserName}}</div>
            <div HJSuppress class="status-value">{{"request.statusChange.UpdatedOn" | translate}}: {{request?.statusUpdatedOn | localizedDate }} </div> 
          </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </dynamic-table>
</div>


